export default {
  accounts: state => {
    return state.accounts;
  }
};
